import { IS_FLIPGIVE } from 'common/env';

/**
 * Returns enrollment strings for check/cheque based on locale (US vs Canadian).
 */
export const enrollmentCheckChequeStrings = {
    noun: IS_FLIPGIVE ? 'cheque' : 'check',
    nounPlural: IS_FLIPGIVE ? 'cheques' : 'checks',
    uploadCta: IS_FLIPGIVE ? 'Upload Cheque' : 'Upload Check',
    uploadTheCta: IS_FLIPGIVE ? 'Upload the cheque' : 'Upload the check',
    uploadModalTitle: IS_FLIPGIVE ? 'Upload cheque' : 'Upload Check',
    uploadVoidedPhotoTitle: IS_FLIPGIVE
        ? 'Upload voided cheque photo'
        : 'Upload Voided Check Photo',
    fundraisingEmail: IS_FLIPGIVE ? 'fundraising@flipgive.com' : 'fundraising@raiseright.com',
    emailCopyPrefix: IS_FLIPGIVE ? ' email a cheque to' : ' email a check to',
    emailTheLabel: IS_FLIPGIVE ? 'Email the cheque' : 'Email the check',
    uploadModalBody: IS_FLIPGIVE
        ? 'Upload a clear image of a cheque or direct deposit form from your bank.'
        : 'Upload a clear image of a check or direct deposit form from your bank.',
    uploadVoidedBody: IS_FLIPGIVE
        ? 'Please upload a voided cheque from your bank. Make sure the account and routing numbers are visible.'
        : 'Please upload a voided check from your bank. Make sure the account and routing numbers are visible.',
    pageTitle: IS_FLIPGIVE ? 'Upload or email a voided cheque' : 'Upload or email a voided check',
    step1Text: IS_FLIPGIVE
        ? 'Take a picture of a voided cheque'
        : 'Take a picture of a voided check',
    earningsTileCta: IS_FLIPGIVE
        ? 'Upload or email a voided cheque to connect a bank account'
        : 'Upload or email a voided check to connect a bank account',
    earningsTileDescription: IS_FLIPGIVE
        ? 'Best option if you need to get information from someone else in your organization, or prefer to share a voided cheque for direct deposit.'
        : 'Best option if you need to get information from someone else in your organization, or prefer to share a voided check for direct deposit.',
    wantToSendInstead: IS_FLIPGIVE
        ? 'Want to send a cheque instead? '
        : 'Want to send a check instead? ',
    emailUsTo: IS_FLIPGIVE ? 'Email us a cheque to' : 'Email us a check to',
    physicalMailedCheckPrograms: IS_FLIPGIVE
        ? 'Physical Mailed Cheque programs'
        : 'Physical Mailed Check programs',
} as const;
